import React, { useState } from 'react';
import FormField from '../components/FormField';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, name }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({ 
          text: '✓ Success! You\'re now subscribed to my newsletter. Welcome to the VIP list! 💕', 
          type: 'success' 
        });
        setEmail('');
        setName('');
      } else {
        setMessage({ 
          text: data.detail || 'Something went wrong. Please try again.', 
          type: 'error' 
        });
      }
    } catch (error) {
      setMessage({ 
        text: 'Unable to subscribe at the moment. Please try again later.', 
        type: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  const newsletterImage = 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/mrld0ov5_Honey%20Sofia%20-%200098-Edit-face%20blur.jpg';

  return (
    <div>
      {/* Split Screen Newsletter Section */}
      <section style={{ 
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'row',
        background: 'var(--bg-primary)',
        position: 'relative'
      }}>
        {/* Image Side - Desktop */}
        <div 
          className="newsletter-image-desktop"
          style={{
            flex: '1',
            minHeight: '100vh',
            backgroundImage: `url(${newsletterImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative'
          }}
        >
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to right, rgba(0,0,0,0.1), rgba(245,241,236,0.2))'
          }}></div>
        </div>

        {/* Form Side */}
        <div 
          className="newsletter-form-container"
          style={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '60px 40px',
            minHeight: '100vh'
          }}
        >
          {/* Mobile Image */}
          <div className="newsletter-image-mobile" style={{
            width: '100%',
            height: '400px',
            backgroundImage: `url(${newsletterImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            marginBottom: '40px'
          }}></div>

          <div style={{ maxWidth: '500px', margin: '0 auto', width: '100%' }}>
            {/* Header */}
            <div style={{ marginBottom: '40px' }}>
              <h1 className="hero-medium" style={{ marginBottom: '16px' }}>
                Stay Connected
              </h1>
              <p className="body-regular" style={{ 
                color: 'var(--text-secondary)', 
                lineHeight: '1.7'
              }}>
                Be the first to know about tour dates, special availability, and exclusive updates.
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name *</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email *</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="form-input"
                />
              </div>

              {/* Message Display */}
              {message.text && (
                <div style={{
                  padding: '16px 20px',
                  marginBottom: '24px',
                  background: message.type === 'success' ? 'rgba(90, 30, 43, 0.1)' : 'rgba(255, 0, 0, 0.1)',
                  border: `1px solid ${message.type === 'success' ? 'var(--burgundy)' : '#ff0000'}`,
                  borderRadius: '2px'
                }}>
                  <p className="body-regular" style={{ 
                    color: message.type === 'success' ? 'var(--burgundy)' : '#cc0000',
                    margin: 0
                  }}>
                    {message.text}
                  </p>
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="btn-primary"
                style={{
                  width: '100%',
                  background: loading ? 'var(--text-light)' : 'var(--burgundy)',
                  color: '#fff',
                  border: loading ? '2px solid var(--text-light)' : '2px solid var(--burgundy)',
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>

            {/* Privacy Note */}
            <p className="body-small" style={{ 
              marginTop: '24px',
              color: 'var(--text-light)',
              lineHeight: '1.6',
              fontStyle: 'italic'
            }}>
              Your information is kept private and will never be shared. You can unsubscribe at any time.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Newsletter;
